/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.7.0 (NJsonSchema v10.3.9.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAPIService {
    /**
     * @return OK
     */
    getPeriod(): Observable<ReportingPeriod>;
    /**
     * Получить информацию о ЛС.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getUserInfo(kh?: number | null | undefined): Observable<UserInfo>;
    /**
     * Получить детализацию начислений.
     * @param kh (optional) Идентификатор.
     * @param period (optional) Последнее число месяца.
     * @return OK
     */
    getCharges(kh?: number | null | undefined, period?: Date | null | undefined): Observable<ChargesInfo[]>;
    /**
     * Получить детализацию начислений.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getPayments(kh?: number | null | undefined): Observable<PaymentInfo[]>;
    /**
     * Получить ссылку на оплату.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getPaymentsURL(kh?: number | null | undefined): Observable<string>;
    /**
     * Квитанция об оплате.
     * @param kh (optional) Идентификатор.
     * @param period (optional) Первое число месяца, за который необходимо получить квитанцию.
     * @return OK
     */
    getInvoice(kh?: number | null | undefined, period?: Date | null | undefined): Observable<void>;
    /**
     * Получить список характеристик лс.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getFeatures(kh?: number | null | undefined): Observable<FeatureInfo[]>;
    /**
     * Получить список документов.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getDocuments(kh?: number | null | undefined): Observable<DocumentInfo[]>;
    /**
     * Получить документ.
     * @param kh (optional) Идентификатор.
     * @param id (optional) Идентификатор документа.
     * @return OK
     */
    getDocumentById(kh?: number | null | undefined, id?: number | null | undefined): Observable<void>;
    /**
     * Получить список счетчиков.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getCounters(kh?: number | null | undefined): Observable<CounterInfo[]>;
    /**
     * Получить список показаний по счетчику.
     * @param id (optional) Идентификатор счетчика.
     * @return OK
     */
    getCounterValues(id?: number | null | undefined): Observable<CounterValue[]>;
    /**
     * Добавить показания ПУ
     * @param body (optional) Параметры для добавления показаний счетчика LKweb.Models.PUValues
     * @return OK
     */
    postValues(body?: PUValues[] | null | undefined): Observable<string>;
    /**
     * Обновить пароль.
     * @param body (optional) Смена пароля.
     * @return OK
     */
    changePassword(body?: PasswordChange | null | undefined): Observable<void>;
    /**
     * Получить список контактов.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getContacts(kh?: number | null | undefined): Observable<Contacts>;
    /**
     * Сохранить контакты.
     * @param body Контакты.
     * @return OK
     */
    postContacts(body: Contacts): Observable<string>;
    /**
     * Сохранить отредактированные показания ПУ.
     * @param body (optional) Параметры для редактирования показания счетчика LKweb.Models.PUValuesEdit.
     * @return OK
     */
    patchEditValue(body?: PUValuesEdit | null | undefined): Observable<string>;
}

@Injectable()
export class APIService implements IAPIService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return OK
     */
    getPeriod(): Observable<ReportingPeriod> {
        let url_ = this.baseUrl + "/api/period";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriod(<any>response_);
                } catch (e) {
                    return <Observable<ReportingPeriod>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReportingPeriod>><any>_observableThrow(response_);
        }));
    }

    protected processGetPeriod(response: HttpResponseBase): Observable<ReportingPeriod> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ReportingPeriod>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReportingPeriod>(<any>null);
    }

    /**
     * Получить информацию о ЛС.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getUserInfo(kh?: number | null | undefined): Observable<UserInfo> {
        let url_ = this.baseUrl + "/api/info?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInfo(<any>response_);
                } catch (e) {
                    return <Observable<UserInfo>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserInfo>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserInfo(response: HttpResponseBase): Observable<UserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserInfo>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserInfo>(<any>null);
    }

    /**
     * Получить детализацию начислений.
     * @param kh (optional) Идентификатор.
     * @param period (optional) Последнее число месяца.
     * @return OK
     */
    getCharges(kh?: number | null | undefined, period?: Date | null | undefined): Observable<ChargesInfo[]> {
        let url_ = this.baseUrl + "/api/charges?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        if (period !== undefined && period !== null)
            url_ += "period=" + encodeURIComponent(period ? "" + period.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCharges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCharges(<any>response_);
                } catch (e) {
                    return <Observable<ChargesInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChargesInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCharges(response: HttpResponseBase): Observable<ChargesInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ChargesInfo[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChargesInfo[]>(<any>null);
    }

    /**
     * Получить детализацию начислений.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getPayments(kh?: number | null | undefined): Observable<PaymentInfo[]> {
        let url_ = this.baseUrl + "/api/payments?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayments(<any>response_);
                } catch (e) {
                    return <Observable<PaymentInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPayments(response: HttpResponseBase): Observable<PaymentInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PaymentInfo[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentInfo[]>(<any>null);
    }

    /**
     * Получить ссылку на оплату.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getPaymentsURL(kh?: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/paymentsURL?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentsURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentsURL(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentsURL(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Квитанция об оплате.
     * @param kh (optional) Идентификатор.
     * @param period (optional) Первое число месяца, за который необходимо получить квитанцию.
     * @return OK
     */
    getInvoice(kh?: number | null | undefined, period?: Date | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/invoice?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        if (period !== undefined && period !== null)
            url_ += "period=" + encodeURIComponent(period ? "" + period.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoice(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Получить список характеристик лс.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getFeatures(kh?: number | null | undefined): Observable<FeatureInfo[]> {
        let url_ = this.baseUrl + "/api/features?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatures(<any>response_);
                } catch (e) {
                    return <Observable<FeatureInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeatureInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetFeatures(response: HttpResponseBase): Observable<FeatureInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FeatureInfo[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureInfo[]>(<any>null);
    }

    /**
     * Получить список документов.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getDocuments(kh?: number | null | undefined): Observable<DocumentInfo[]> {
        let url_ = this.baseUrl + "/api/docs?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(<any>response_);
                } catch (e) {
                    return <Observable<DocumentInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<DocumentInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DocumentInfo[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentInfo[]>(<any>null);
    }

    /**
     * Получить документ.
     * @param kh (optional) Идентификатор.
     * @param id (optional) Идентификатор документа.
     * @return OK
     */
    getDocumentById(kh?: number | null | undefined, id?: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/docs/GetDocumentById?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentById(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processGetDocumentById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Получить список счетчиков.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getCounters(kh?: number | null | undefined): Observable<CounterInfo[]> {
        let url_ = this.baseUrl + "/api/counters?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCounters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCounters(<any>response_);
                } catch (e) {
                    return <Observable<CounterInfo[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CounterInfo[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCounters(response: HttpResponseBase): Observable<CounterInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CounterInfo[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CounterInfo[]>(<any>null);
    }

    /**
     * Получить список показаний по счетчику.
     * @param id (optional) Идентификатор счетчика.
     * @return OK
     */
    getCounterValues(id?: number | null | undefined): Observable<CounterValue[]> {
        let url_ = this.baseUrl + "/api/values?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCounterValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCounterValues(<any>response_);
                } catch (e) {
                    return <Observable<CounterValue[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<CounterValue[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCounterValues(response: HttpResponseBase): Observable<CounterValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CounterValue[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CounterValue[]>(<any>null);
    }

    /**
     * Добавить показания ПУ
     * @param body (optional) Параметры для добавления показаний счетчика LKweb.Models.PUValues
     * @return OK
     */
    postValues(body?: PUValues[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostValues(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostValues(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Обновить пароль.
     * @param body (optional) Смена пароля.
     * @return OK
     */
    changePassword(body?: PasswordChange | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/changePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Получить список контактов.
     * @param kh (optional) Идентификатор.
     * @return OK
     */
    getContacts(kh?: number | null | undefined): Observable<Contacts> {
        let url_ = this.baseUrl + "/api/contacts?";
        if (kh !== undefined && kh !== null)
            url_ += "kh=" + encodeURIComponent("" + kh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContacts(<any>response_);
                } catch (e) {
                    return <Observable<Contacts>><any>_observableThrow(e);
                }
            } else
                return <Observable<Contacts>><any>_observableThrow(response_);
        }));
    }

    protected processGetContacts(response: HttpResponseBase): Observable<Contacts> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Contacts>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Contacts>(<any>null);
    }

    /**
     * Сохранить контакты.
     * @param body Контакты.
     * @return OK
     */
    postContacts(body: Contacts): Observable<string> {
        let url_ = this.baseUrl + "/api/contacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostContacts(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPostContacts(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * Сохранить отредактированные показания ПУ.
     * @param body (optional) Параметры для редактирования показания счетчика LKweb.Models.PUValuesEdit.
     * @return OK
     */
    patchEditValue(body?: PUValuesEdit | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/updateValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatchEditValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatchEditValue(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPatchEditValue(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface ITokenService {
    /**
     * Получить пару access/refresh-токенов по логину/паролю
     * @param body (optional) Пара логин/пароль LKweb.Models.LoginPasswordModel
     * @return OK
     */
    getToken(body?: LoginPasswordModel | null | undefined): Observable<TokenModel>;
    /**
     * Создание кода авторизации с отправкой пользователю.
     * @param body Номер телефона и ЛС.
     * @return OK
     */
    sendVerifyCode(body: PhoneNumber): Observable<AuthorizationDataResponse>;
    /**
     * Получить пару access/refresh-токенов по коду авторизации.
     * @param body Данные для верификации.
     * @return OK
     */
    getTokenByCode(body: AuthorizationData): Observable<TokenModel>;
}

@Injectable()
export class TokenService implements ITokenService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Получить пару access/refresh-токенов по логину/паролю
     * @param body (optional) Пара логин/пароль LKweb.Models.LoginPasswordModel
     * @return OK
     */
    getToken(body?: LoginPasswordModel | null | undefined): Observable<TokenModel> {
        let url_ = this.baseUrl + "/api/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(<any>response_);
                } catch (e) {
                    return <Observable<TokenModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TokenModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<TokenModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TokenModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenModel>(<any>null);
    }

    /**
     * Создание кода авторизации с отправкой пользователю.
     * @param body Номер телефона и ЛС.
     * @return OK
     */
    sendVerifyCode(body: PhoneNumber): Observable<AuthorizationDataResponse> {
        let url_ = this.baseUrl + "/api/token/sendCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerifyCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerifyCode(<any>response_);
                } catch (e) {
                    return <Observable<AuthorizationDataResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthorizationDataResponse>><any>_observableThrow(response_);
        }));
    }

    protected processSendVerifyCode(response: HttpResponseBase): Observable<AuthorizationDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthorizationDataResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthorizationDataResponse>(<any>null);
    }

    /**
     * Получить пару access/refresh-токенов по коду авторизации.
     * @param body Данные для верификации.
     * @return OK
     */
    getTokenByCode(body: AuthorizationData): Observable<TokenModel> {
        let url_ = this.baseUrl + "/api/token/byCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTokenByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTokenByCode(<any>response_);
                } catch (e) {
                    return <Observable<TokenModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TokenModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetTokenByCode(response: HttpResponseBase): Observable<TokenModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TokenModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenModel>(<any>null);
    }
}

export interface IPostService {
    /**
     * Обновить access-токен.
     * @param body (optional) Просроченый access-токен и актуальный refresh-токен.LKweb.Models.TokenModel
     * @return OK
     */
    refresh(body?: TokenModel | null | undefined): Observable<TokenModel>;
    /**
     * Отозвать refresh-токен.
     * @param body (optional) refresh-токен.
     * @return OK
     */
    revoke(body?: TokenModel | null | undefined): Observable<void>;
    /**
     * Отозвать все refresh-токены.
     * @return OK
     */
    revokeAll(): Observable<void>;
}

@Injectable()
export class PostService implements IPostService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Обновить access-токен.
     * @param body (optional) Просроченый access-токен и актуальный refresh-токен.LKweb.Models.TokenModel
     * @return OK
     */
    refresh(body?: TokenModel | null | undefined): Observable<TokenModel> {
        let url_ = this.baseUrl + "/api/token/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(<any>response_);
                } catch (e) {
                    return <Observable<TokenModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<TokenModel>><any>_observableThrow(response_);
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<TokenModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TokenModel>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenModel>(<any>null);
    }

    /**
     * Отозвать refresh-токен.
     * @param body (optional) refresh-токен.
     * @return OK
     */
    revoke(body?: TokenModel | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/token/revoke";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevoke(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevoke(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRevoke(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Отозвать все refresh-токены.
     * @return OK
     */
    revokeAll(): Observable<void> {
        let url_ = this.baseUrl + "/api/token/revokeAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeAll(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRevokeAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 490) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result490: any = null;
            result490 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result490);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

/** Информация для регистрации аккаунта по коду. */
export interface AuthorizationData {
    /** Номер ЛС. */
    koD_LSCH: number;
    /** email. */
    email: string;
    /** Номер телефона пользователя. */
    phone: string;
    /** Пароль. */
    password: string;
    /** Код авторизации. */
    code: string;
    /** Короткий код аутентификации. */
    shortCode?: number | undefined;
}

/** Замаскированная почта пользователя в ответе. */
export interface AuthorizationDataResponse {
    /** Замаскированная почта пользователя. */
    masked?: string | undefined;
    /** Текст ответа пользователяю. */
    text?: string | undefined;
    /** Идентификатор службы отправки сообщения: email, telegram, phoneCall, sms.
            В поле serviceId выводить значение phone (или какое соответствует звонку на телефон) для первой авторизации пользователя (эта логика остаётся прежней). В остальных случаях безусловно выводить значение mail(или какое соответствует отправке на почту) */
    serviceId?: string | undefined;
    /** Короткий код, который требуется для аутентификации пользователя, вводящего код подтвеждения позже. */
    shortCode?: number | undefined;
}

/** Детализация начислений. */
export interface ChargesInfo {
    /** Наименование услуги. */
    serviceName?: string | undefined;
    /** Ед.изм. */
    unit?: string | undefined;
    /** Тариф. */
    tariff?: number | undefined;
    /** Начислено по тарифу. */
    rate?: number | undefined;
    /** Сумма льготы. */
    benefitAmount?: number | undefined;
    /** Сумма перерасчета. */
    allocationAmount?: number | undefined;
    /** Итого к оплате. */
    total?: number | undefined;
    /** Количество услуги. */
    volume?: number | undefined;
}

export interface Contact {
    /** Идентификатор. */
    id?: number | undefined;
    /** Телефон/email. */
    value?: string | undefined;
    /** Получать рассылку. */
    iWish?: boolean | undefined;
    /** Номер ЛС. */
    kh?: number | undefined;
}

/** Список телефонов и email. */
export interface Contacts {
    /** Список телефонов. */
    phones?: Contact[] | undefined;
    /** Список email. */
    emails?: Contact[] | undefined;
}

/** Информация по счетчику. */
export interface CounterInfo {
    /** Наименование счетчика. */
    counterName?: string | undefined;
    /** Последние показание. */
    lastValue?: number | undefined;
    /** Дата последнего показания. */
    lastValueDate?: Date | undefined;
    /** Номер счетчика. */
    counterNumber?: string | undefined;
    /** Дата поверки. */
    verificationDate?: Date | undefined;
    /** Дата установки. */
    installationDate?: Date | undefined;
    /** Идентификатор счетчика. */
    pU_ID?: number | undefined;
    /** Идентификатор последнго показания. */
    lastValueID?: number | undefined;
}

/** Показания по счетчику. */
export interface CounterValue {
    /** Дата показания. */
    valueDate?: Date | undefined;
    /** Показание. */
    value?: number | undefined;
    /** Источник передачи. */
    source?: string | undefined;
    /** Идентификатор показания счетчика за последний месяц. */
    valueId?: number | undefined;
}

/** Информация по документу. */
export interface DocumentInfo {
    /** Идентификатор документа. */
    id?: number | undefined;
    /** Наименование группы. */
    groupName?: string | undefined;
    /** Наименование документа. */
    documentName?: string | undefined;
}

/** Список характеристик ЛС. */
export interface FeatureInfo {
    /** Наименование группы. */
    groupName?: string | undefined;
    /** Наименование характеристики. */
    featureName?: string | undefined;
    /** Значение. */
    featureValue?: string | undefined;
}

/** Логин/пароль */
export interface LoginPasswordModel {
    /** Номер ЛС. */
    login?: number | undefined;
    /** пароль */
    password?: string | undefined;
}

/** Внесение показаний ПУ */
export interface PUValues {
    /** Идентификатор ПУ */
    pU_ID?: number | undefined;
    /** Показания счетчика */
    value?: number | undefined;
}

/** Внесение показаний ПУ */
export interface PUValuesEdit {
    /** Идентификатор ПУ */
    pU_ID?: number | undefined;
    /** Показания счетчика */
    value?: number | undefined;
    /** Идентификатор записи показаний текущего периода. */
    valueid?: number | undefined;
}

/** Смена пароля. */
export interface PasswordChange {
    /** Старый пароль. */
    oldPassword?: string | undefined;
    /** Новый пароль. */
    newPassword?: string | undefined;
    /** Подтверждение нового пароля. */
    newPasswordCompare?: string | undefined;
}

/** Оплата. */
export interface PaymentInfo {
    /** Дата оплаты. */
    paymentDate?: Date | undefined;
    /** Период учета. */
    period?: Date | undefined;
    /** Сумма оплаты. */
    paymentAmount?: number | undefined;
    /** UUID оплаты из ЛК. */
    uuid?: string | undefined;
    /** Ссылка на чек. */
    receipt_link?: string | undefined;
}

/** Номер телефона. */
export interface PhoneNumber {
    /** Номер телефона пользователя. */
    phone: string;
    /** Номер ЛС пользователя. */
    koD_LSCH?: number | undefined;
}

export interface ReportingPeriod {
    from?: number | undefined;
    to?: number | undefined;
}

/** access/refresh-токены */
export interface TokenModel {
    /** access-токен */
    token?: string | undefined;
    /** refresh-токен */
    refreshToken?: string | undefined;
}

/** Информация о ЛС. */
export interface UserInfo {
    /** Номер ЛС. */
    kod_lsch?: number | undefined;
    /** Address. */
    address?: string | undefined;
    /** ФИО. */
    userFullName?: string | undefined;
    /** День начала передачи счетчиков */
    begin_Counters?: number | undefined;
    /** День окончания передачи счетчиков */
    end_Counters?: number | undefined;
    /** Сумма баланса. */
    balance?: number | undefined;
    /** Дата последней передачи показаний. */
    lasT_VALUE_DATE?: Date | undefined;
    /** Дата последней квитанции. */
    lasT_KVIT_DATE?: Date | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}